import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appOnlyNumbersInput]'
})
export class OnlyNumbersInputDirective {

  private navigationKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'Home',
    'End',
    'ArrowLeft',
    'ArrowRight',
    'Clear',
    'Copy',
    'Paste',
  ];

  @Input() prefijo = "";

  inputElement: HTMLInputElement;

  constructor(private _el: ElementRef) {
    // console.log('[OnlyLettersInputDirective] directive')
    this.inputElement = _el.nativeElement;
  }

  // @HostListener('input', ['$event'])
  // onInputChange(event) {
  //   const initalValue = this.inputElement.value;
  //   this.inputElement.value = initalValue.replace(/[^a-zA-Z ]/g, '');
  //   if (initalValue !== this.inputElement.value) {
  //     event.stopPropagation();
  //   }
  // }

  sanitizeText(text: string) {
    const pattern: RegExp = /[^0-9]/g
    return text.replace(pattern, '');
  }

  // @HostListener('change', ['$event'])
  // onChange(e: any): void {
  //   // console.log('[OnlyLettersInputDirective] onChange')
  //   const initalValue = this.inputElement.value;
  //   this.inputElement.value = this.sanitizeText(initalValue); //initalValue.replace(/[^a-zA-Z ]/g, '');
  //   if (initalValue !== this.inputElement.value) {
  //     e.stopPropagation();
  //   }
  // }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent): any {
    // console.log('[OnlyLettersInputDirective] onKeyDown', this.forecastValue(e.key), this.cleanText(this.forecastValue(e.key)))
    if (
      this.navigationKeys.indexOf(e.key) > -1 || // Allow: navigation keys: backspace, delete, arrows etc.
      ((e.key === 'a' || e.code === 'KeyA') && e.ctrlKey === true) || // Allow: Ctrl+A
      ((e.key === 'c' || e.code === 'KeyC') && e.ctrlKey === true) || // Allow: Ctrl+C
      ((e.key === 'v' || e.code === 'KeyV') && e.ctrlKey === true) || // Allow: Ctrl+V
      ((e.key === 'x' || e.code === 'KeyX') && e.ctrlKey === true) || // Allow: Ctrl+X
      ((e.key === 'a' || e.code === 'KeyA') && e.metaKey === true) || // Allow: Cmd+A (Mac)
      ((e.key === 'c' || e.code === 'KeyC') && e.metaKey === true) || // Allow: Cmd+C (Mac)
      ((e.key === 'v' || e.code === 'KeyV') && e.metaKey === true) || // Allow: Cmd+V (Mac)
      ((e.key === 'x' || e.code === 'KeyX') && e.metaKey === true) // Allow: Cmd+X (Mac)
    ) {
      // let it happen, don't do anything
      return;
    }

    let initialValue = this.inputElement.value;
    if (initialValue.length > this.prefijo.length)
      initialValue = initialValue.substr(this.prefijo.length);
    this.inputElement.value = this.prefijo + this.sanitizeText(initialValue);
    if (initialValue !== this.inputElement.value) {
      e.stopPropagation();
    }
  }

  @HostListener('keyup', ['$event'])
  onKeyUp(e: KeyboardEvent): any {
    if (
      this.navigationKeys.indexOf(e.key) > -1 || // Allow: navigation keys: backspace, delete, arrows etc.
      ((e.key === 'a' || e.code === 'KeyA') && e.ctrlKey === true) || // Allow: Ctrl+A
      ((e.key === 'c' || e.code === 'KeyC') && e.ctrlKey === true) || // Allow: Ctrl+C
      ((e.key === 'v' || e.code === 'KeyV') && e.ctrlKey === true) || // Allow: Ctrl+V
      ((e.key === 'x' || e.code === 'KeyX') && e.ctrlKey === true) || // Allow: Ctrl+X
      ((e.key === 'a' || e.code === 'KeyA') && e.metaKey === true) || // Allow: Cmd+A (Mac)
      ((e.key === 'c' || e.code === 'KeyC') && e.metaKey === true) || // Allow: Cmd+C (Mac)
      ((e.key === 'v' || e.code === 'KeyV') && e.metaKey === true) || // Allow: Cmd+V (Mac)
      ((e.key === 'x' || e.code === 'KeyX') && e.metaKey === true) // Allow: Cmd+X (Mac)
    ) {
      // let it happen, don't do anything
      return;
    }

    let initialValue = this.inputElement.value;
    if (initialValue.length > this.prefijo.length)
      initialValue = initialValue.substr(this.prefijo.length);
    this.inputElement.value = this.sanitizeText(initialValue); //initalValue.replace(/[^a-zA-Z ]/g, '');
    if (initialValue !== this.inputElement.value) {
      e.stopPropagation();
    }
    this.inputElement.value = this.prefijo + this.inputElement.value
  }

  @HostListener('paste', ['$event'])
  onPaste(event: any): void {
    let pastedInput: string;
    if (window['clipboardData']) {
      // Browser is IE
      pastedInput = window['clipboardData'].getData('text');
    } else if (event.clipboardData && event.clipboardData.getData) {
      // Other browsers
      pastedInput = event.clipboardData.getData('text/plain');
    }

    this.inputElement.value = this.sanitizeText(pastedInput);
    event.preventDefault();
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent): void {
    const textData = event.dataTransfer.getData('text');
    this.inputElement.focus();
    this.inputElement.value = this.sanitizeText(textData);
    event.preventDefault();
  }

  private forecastValue(key: string): string {
    const selectionStart = this.inputElement.selectionStart;
    const selectionEnd = this.inputElement.selectionEnd;
    const oldValue = this.inputElement.value;
    const selection = oldValue.substring(selectionStart, selectionEnd);
    return selection
      ? oldValue.replace(selection, key)
      : oldValue.substring(0, selectionStart) +
      key +
      oldValue.substring(selectionStart);
  }
}
